import apiService, { getDefaultHeader, getDSEHeader, getCdmsBaseUrl, getDseUrl, getMediaUrl } from './apiService';
import HTTP from './apiService/httpClient';
import { URL_TYPES } from '../constants/api';
import { EMPTY_OBJECT } from '../app.constants';
var MEDIA_V3_PRESIGNING_URL = '/media-v3/u/v2/presignedurls';

var getCDMSBaseURL = function getCDMSBaseURL() {
  return getCdmsBaseUrl();
};

var getMediaUrls = function getMediaUrls(file) {
  var apiUrl = '/w/u/upload';
  var baseMediaURL = "".concat(getMediaUrl());
  return apiService(baseMediaURL, getDefaultHeader()).post(apiUrl, file, {
    attachment: true,
    async: false
  }).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};
/**
 * @deprecated
 * PDF Service will Start Uploading using Media-v3
 */


var getCDMSSignedUrls = function getCDMSSignedUrls(mediaIdObject) {
  var apiUrl = '/r/u/presignedurls';
  var baseMediaURL = "".concat(getMediaUrl());
  return apiService(baseMediaURL, getDefaultHeader()).post(apiUrl, mediaIdObject).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
};

var getCDMSSignedUrlsFromMediaV3 = function getCDMSSignedUrlsFromMediaV3(mediaIdObject) {
  return HTTP.post(URL_TYPES.CDMS, MEDIA_V3_PRESIGNING_URL, mediaIdObject).then(function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
        data = _ref3.data;

    return data;
  });
};

var getDSESignedUrls = function getDSESignedUrls(mediaIdObject) {
  var apiUrl = '/tmedia/signed/URLs';
  var baseMediaURL = "".concat(getDseUrl());
  return apiService(baseMediaURL, getDSEHeader()).post(apiUrl, mediaIdObject).then(function (_ref4) {
    var data = _ref4.data;
    return data;
  });
};

export { getDefaultHeader as getHeaders, getCDMSBaseURL as getBaseURL };
export default {
  getMediaUrls: getMediaUrls,
  getCDMSSignedUrls: getCDMSSignedUrls,
  getDSESignedUrls: getDSESignedUrls,
  getCDMSSignedUrlsFromMediaV3: getCDMSSignedUrlsFromMediaV3
};